module.exports = __webpack_public_path__ + "Icono_Check_126px.png";